const breadCrumbsStyle = Object.freeze({
  typeScale: Object.freeze([
    Object.freeze({ from: 'l', value: -1, }),
  ]),
  nameMapping: {},
});

export default breadCrumbsStyle;
